module.exports = __webpack_public_path__ + "static/media/CHOD.5dbec588.png";